(function(root, factory) {
  'use strict';
  if (typeof exports === 'object') {
    // CommonJS
    module.exports = factory(require('@ali/simple-ua'), require('@ali/network'), require('@ali/share-data'));
  } else {
    // Global Variables
    root.UEM = root.UEM || {};
    root.UEM.ShareIntl = factory(root.UEM.ua, root.UEM.network, root.UEM.shareData);
  }
})(this, function(ua, net, shareData) {
  'use strict';

  function ShareIntl() {}

  /**
   * share api
   */
  ShareIntl.API = {
    FACEBOOK: 'https://m.facebook.com/dialog/feed',
    FACEBOOK_SIMPLE: 'http://www.facebook.com/share.php?u=',
    VK: 'http://vk.com/share.php',
    VKCLI: 'vk://vk.com/share.php', // VK客户端
    OK_SIMPLE: 'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=',
    TWITTER: 'https://twitter.com/intent/tweet?'
  };

  /**
   * share app id
   */
  ShareIntl.APP_ID = {
    // 此 Facebook APP_ID 与客户端共享，客户端联系人 wanmin.lwm@alibaba-inc.com
    // 此 Facebook 应用管理权限联系 kyle.zk@alibaba-inc.com 或 lizhenqiang.lzq@alibaba-inc.com
    // FACEBOOK: '869428466573423' // 借用其他业务方appid进行使用
    FACEBOOK: '2251143295120050' // 新appid
  };

  /**
   * redirect url
   * 分享组件的回跳接口，先跳这个再跳业务方提供的真正回跳地址
   * 负责人: zhu.zxm@alibaba-inc.com
   */
  ShareIntl.RedirectUrl = 'http://share.ucweb.com/share/share/share/done?callback='

  /**
   * get facebook share url
   */
  ShareIntl.facebook = function(title, content, link, image, redirect) {
    link = addShareDataParam2Link(link);

    var url = this.API.FACEBOOK;

    url += '?app_id=' + this.APP_ID.FACEBOOK;

    // 处理在FACEBOOK客户端中再次分享时，链接的参数只保留了第一个，其余参数被截断的问题 -- 20170306
    var originPath = link.substring(0, link.indexOf('?') + 1);
    var queryString = link.substring(link.indexOf('?') + 1);
    if (!ua.isIOS() && ua.pf === 'FACEBOOK') {
      var fbVersion = getFbVersion();
      // 目前测试版本号在54~113之间都存在这个问题，如果fb版本后续升级不存在这个问题了，可修改这里的版本号
      if (fbVersion >= 54) {
        url += '&link=' + encodeURIComponent(originPath) + encodeURIComponent(encodeURIComponent(queryString));
      } else {
        url += '&link=' + encodeURIComponent(link || '');
      }
    } else {
      url += '&link=' + encodeURIComponent(link || '');
    }
    
    url += '&redirect_uri=' +
        encodeURIComponent(this.RedirectUrl + encodeURIComponent(redirect || ''));


    return url;
  };

  /**
   * facebook simple share
   */
  ShareIntl.facebookSimple = function(link) {
    link = addShareDataParam2Link(link);

    var url = this.API.FACEBOOK_SIMPLE;

    return url += encodeURIComponent(link);
  };

  /**
   * call ucbrowser share model
   */
  ShareIntl.whatsapp = function(text, link) {
    link = addShareDataParam2Link(link);

    window.location.href = 'whatsapp://send?' +
        'text=' + encodeURIComponent(text) + '%20' + encodeURIComponent(link);
  };

  /**
   * russia ok share
   */
  ShareIntl.ok = function(link) {
    link = addShareDataParam2Link(link);
    return this.API.OK_SIMPLE + encodeURIComponent(link);
  };

  /**
   * russia vk share
   */
  ShareIntl.vk = function(title, content, link, image) {

    var url = this.API.VK;

    link = addShareDataParam2Link(link);

    url += '?url=' + encodeURIComponent(link || '');

    url += '&title=' + encodeURIComponent(title || '');

    url += '&description=' + encodeURIComponent(content || '');

    url += '&image=' + encodeURIComponent(image || '');

    return url;
  };
/**
 * 
 * vk share in client
 */
  ShareIntl.vkCli = function(title, content, link, image) {
    var url = this.API.VKCLI;
    link = addShareDataParam2Link(link);

    url += '?url=' + encodeURIComponent(link || '')
    
    url += '&title=' + encodeURIComponent(title || '');

    url += '&description=' + encodeURIComponent(content || '');

    url += '&image=' + encodeURIComponent(image || '');

    return url;
  }

  /**
   * twitter share
   */
  ShareIntl.twitter = function(text, link) {
    var url = this.API.TWITTER;
    link = addShareDataParam2Link(link);
    url += 'text=' + encodeURIComponent(text || '');
    url += '&url=' + encodeURIComponent(link || '');
    return url;
  };


  ShareIntl.ucShare = function(opt) {
    initOpt(opt);
    opt.link = addShareDataParam2Link(opt.link);
    if (!isIOS()) {
      ucAndroidShare(opt);
    } else {
      ucIOSShare(opt);
    }
  };

  function isIOS() {
    return window.navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ? true : false;
  }
  function isNews() {
    return window.navigator.userAgent.toLowerCase().indexOf('ucnews') >= 0;
  }

  function initOpt(opt) {
    opt.title = opt.title || '';
    opt.desc = opt.desc || '';
    opt.link = opt.link || 'http://uc.cn';
    opt.platform = opt.platform || '';
    opt.disableTarget = '';
    opt.domId = opt.domId || '';
  }

  function ucAndroidShare(opt) {
    ucweb.startRequest('shell.page_share',   [
      opt.title,
      opt.desc,
      opt.link,
      opt.platform,
      opt.disableTarget,
      '',
      getNodeInfoById(opt.domId)
    ]);
  }

  function ucIOSShare(opt) {
    ucbrowser.web_share(
        opt.title,
        opt.desc,
        opt.link,
        opt.platform,
        '',
        '',
        opt.domId);
  }

  function addShareDataParam2Link(link) {
    var SHARE_DATA_PARAM_NAME = '__sd';
    var shareDataReg = new RegExp(SHARE_DATA_PARAM_NAME + '=[^&]*[&]', 'g');
    try {
      var lastNodeDeep = 0;
      try {
        lastNodeDeep = shareData.decodeShareData(net.query(SHARE_DATA_PARAM_NAME)).deep;
      } catch (e) {}
      link = net.parseQuery({
        __sd: shareData.encodeShareData({
          sessionid: ua.getSessionId(),
          deep: ++lastNodeDeep,
          type: 0, // 0: 链接, 1: 图片
          style: 0, // 样式id保留后续用作优化分享
        })
      }, link.replace(shareDataReg, ''));
    } catch (e) {}
    return link;
  }

  /**
   * 获取FACEBOOK客户端版本号
   */
  function getFbVersion() {
    var ua = window.navigator.userAgent.toLowerCase();
    try {
      var match = ua.match(/;fbav\/([0-9\.]*)/);
      if (match) {
        return parseInt(match[1]);
      }
    } catch(e){}
    return 0;
  }

  /**
   * ========== 以下为客户端同学提供的代码 T T ===========
   **/
  function getTop(e) {
    var offset = e.offsetTop;
    offset += e.offsetParent != null ? offset += getTop(e.offsetParent) : 0;
    return offset;
  }

  function getLeft(e) {
    var offset = e.offsetLeft;
    offset += e.offsetParent != null ? getLeft(e.offsetParent) : 0;
    return offset;
  }

  function getCss3offsetTop(e) {
    var css3offset = getComputedStyle(e, null).webkitTransform,
        css3offsetTop;
    if (css3offset === 'none') {
      css3offsetTop = 0;
    } else { //存在CSS3属性
      css3offsetTop = parseInt(css3offset.split(',')[5].replace(')', ''), 10);
    }
    css3offsetTop += e.parentNode.tagName !== 'BODY' ? getCss3offsetTop(e.parentNode) : 0;
    return css3offsetTop;
  }

  function getCss3offsetLeft(e) {
    var css3offset = getComputedStyle(e, null).webkitTransform,
        css3offsetLeft;
    if (css3offset === 'none') {
      css3offsetLeft = 0;
    } else { //存在CSS3属性
      css3offsetLeft = parseInt(css3offset.split(',')[4], 10);
    }
    css3offsetLeft += e.parentNode.tagName !== 'BODY' ? getCss3offsetLeft(e.parentNode) : 0;
    return css3offsetLeft;
  }

  function getNodeInfoById(e) {
    var myNode = document.getElementById(e);
    if (myNode) {
      var pos = [getLeft(myNode) + getCss3offsetLeft(myNode), getTop(myNode) + getCss3offsetTop(myNode), myNode.offsetWidth, myNode.offsetHeight];
      return (pos);
    } else {
      return '';
    }
  }
  return ShareIntl;
});